export default "__VITE_ASSET__BVC6qsBo__"